import { createApp } from 'vue'
import App from './App.vue'
import ScrollAnimation from './directives/fadeonscroll'
import router from './router'
import store from './store'

createApp(App).directive('scrollanimation', ScrollAnimation).use(store).use(router).mount('#app')
